import {FormControl, TextField} from "@mui/material";
import styled from "styled-components";
import {media} from "../../../theme";

export const UserEditWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    width: 100%;
    padding: 20px 0;
    
    ${media.md} {
        grid-template-columns: 1fr 1fr;
    }
`;

export const UserEditForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
`;

export const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: none;
`;

export const StyledFormControl = styled(FormControl)`
    width: 100%;
    max-width: none;
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    button {
        width: 100%;
    }

    ${media.sm} {
        flex-direction: row;

        button {
            width: auto;
        }

        justify-content: flex-end;
    }
`;
